enum VIEWS {
  instructions = 'instrucciones',
  camera = 'camara',
  preview = 'preview',
}

export default VIEWS
